export const ENTER_KEYCODE = 13
export const ESCAPE_KEYCODE = 27
export const COMMA_KEYCODE = 188
export const LEFT_KEYCODE = 37
export const RIGHT_KEYCODE = 39
export const DELETE_KEYCODE = 46
export const BACKSPACE_KEYCODE = 8
